import { Box, Heading, SimpleGrid, GridItem } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import { WHY_ENTERPRISES_MIGRATE_CONSTANTS } from "./constants";
import { AdvantageCard } from "@/components/advantageCard";
import bgImage from "public/openStack/diffrenceBG.png";

const WhyMigrateToMost = () => {
  return (
    <Box bgImage={`url(${bgImage.src})`} bgSize="cover" pb={20}>
      <PageLayout marginTop={0}>
        <Box>
          <Heading
            as="h2"
            fontWeight={"400"}
            textAlign={"center"}
            fontSize={"40px"}
            color={"white"}
            my={12}
          >
            Why Enterprises Migrate to MOST
          </Heading>
          <SimpleGrid columns={{ base: 1, sm: 2, md: 5 }} gap={12}>
            {WHY_ENTERPRISES_MIGRATE_CONSTANTS.map((item, index) => (
              <GridItem key={index}>
                <AdvantageCard
                  text={item.text}
                  image={item.image}
                  title={item.title}
                  textColor={"white"}
                  headingColor={"white"}
                  alignDirection="center"
                  getHoverEffect
                />
              </GridItem>
            ))}
          </SimpleGrid>
        </Box>
      </PageLayout>
    </Box>
  );
};

export default WhyMigrateToMost;
